export const defaultPlaceholder = {
  ACTIVITY: 'What?',
  ACTIVITY_SFA: 'CardName',
  TEXT: 'Text',
  FLOWLINE: 'Why?'
} as const;

export const defaultStickerPaper = 'yellow-paper-gold';

export const AGENT_FORCE_DATA_TYPES = {
  INSTRUCTIONS: 'instructions',
  UTTERANCES: 'test-utterances'
} as const;

export type AgentForceDataType =
  (typeof AGENT_FORCE_DATA_TYPES)[keyof typeof AGENT_FORCE_DATA_TYPES];
